import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './lang/i18n';
import { applyTranslationPatch } from './utils/translation_patches';

applyTranslationPatch();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);